module.exports = __webpack_public_path__ + "img/hm_block03_03_en.f5adf069.png";